import React, {useRef, useState} from 'react'
import {Checkbox, Button, notification} from 'antd'
import {PhoneOutlined, MobileOutlined} from '@ant-design/icons'
import {SignaturePad} from 'components/shared'

const ApproveProductChanges = ({
  hasChanges,
  brokerPhone,
  onSubmit,
  isSubmitting,
  submitLabel = 'Lagre',
  additionalButtons = null,
}) => {
  const signaturePad = useRef(null)
  const [approvedByBroker, setApprovedByBroker] = useState(false)
  const [approvedBySeller, setApprovedBySeller] = useState(false)

  const needsSignature = approvedBySeller && !approvedByBroker
  const canSubmit = hasChanges && !isSubmitting && (approvedByBroker || approvedBySeller)

  function submit() {
    if (approvedByBroker && approvedBySeller) {
      notification.error({
        message: 'Valideringsfeil',
        description: 'Mersalget kan ikke godkjennes av både megler og selger. Velg en av partene.',
      })
      return
    }

    const data = {
      approvedByBroker,
      approvedBySeller,
    }

    if (needsSignature) {
      if (signaturePad.current.isEmpty()) {
        notification.error({
          message: 'Mangler signatur',
          description: 'Boligselger må signere',
        })
        return
      }

      data.sellerSignatureBase64 = signaturePad.current.toDataURL()
    }

    return onSubmit(data)
  }


  return (
    <div className="approve-product-changes">
      <p className="section notice">Om ikke megler har godkjent salget må boligselger godkjenne med sin signatur.</p>

      <div className="section contact-details">
        <a href={`tel:${brokerPhone}`}>
          <Button icon={<PhoneOutlined />}>Ring megler</Button>
        </a>
        <a href={`sms:${brokerPhone}`}>
          <Button icon={<MobileOutlined />}>SMS megler</Button>
        </a>
      </div>

      <div className="section confirmed-by">
        <div className="broker">
          <Checkbox
            checked={approvedByBroker}
            onChange={e => setApprovedByBroker(e.target.checked)}
          >
            Godkjent av megler
          </Checkbox>
        </div>
        <div className="seller">
          <Checkbox
            checked={approvedBySeller}
            onChange={e => setApprovedBySeller(e.target.checked)}
          >
            Godkjent av selger
          </Checkbox>
        </div>
      </div>

      {needsSignature && (
        <div className="section signature">
          <div>Selgers signatur:</div>
          <SignaturePad ref={ref => signaturePad.current = ref} />
        </div>
      )}

      <Button
        type="primary"
        loading={isSubmitting}
        disabled={!canSubmit}
        onClick={submit}
      >
        {submitLabel}
      </Button>

      {additionalButtons}
    </div>
  )
}

export default ApproveProductChanges
